
import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import { workflowHelpers } from '@/components/mixins/workflowHelpers';

import {
	NodeParameterValue,
} from 'n8n-workflow';

export default mixins(
	workflowHelpers,
)
	.extend({
	name: 'TextEdit',
	props: [
		'dialogVisible',
		'parameter',
		'path',
		'value',
	],
	data () {
		return {
			tempValue: '', // el-input does not seem to work without v-model so add one
		};
	},
	methods: {
		valueChanged (value: string) {
			this.$emit('valueChanged', value);
		},

		closeDialog () {
			// Handle the close externally as the visible parameter is an external prop
			// and is so not allowed to be changed here.
			this.$emit('closeDialog');
			return false;
		},
	},
	computed: {
		expressionValueComputed (): NodeParameterValue | null {

			let computedValue: NodeParameterValue;

			try {
				computedValue = this.resolveExpression(this.value) as NodeParameterValue;
			} catch (error) {
				computedValue = `[${this.$locale.baseText('parameterInput.error')}}: ${error.message}]`;
			}

			// Try to convert it into the corret type
			if (this.parameter.type === 'number') {
				computedValue = parseInt(computedValue as string, 10);
				if (isNaN(computedValue)) {
					return null;
				}
			}

			return computedValue;
		},
		isValueExpression () {
			if (this.parameter.noDataExpression === true) {
				return false;
			}
			if (typeof this.value === 'string' && this.value.charAt(0) === '=') {
				return true;
			}
			return false;
		},
	},
	mounted () {
		this.tempValue = this.value as string;
	},
	watch: {
		dialogVisible () {
			if (this.dialogVisible === true) {
				Vue.nextTick(() => {
					(this.$refs.inputField as HTMLInputElement).focus();
				});
			}
		},
		value () {
			this.tempValue = this.value as string;
		},
	},
});
